import { createFeatureSelector, createSelector } from '@ngrx/store';

import { HmState, User } from '@hm/core/models/hm-state.interface';

const DEFAULT_USER_NAME = `Менеджер здоров'я`;

export const selectUserState = createFeatureSelector<HmState>('hm');

export const selectUser = createSelector(selectUserState, (state: HmState) => state.user);
export const selectUserName = createSelector(selectUser, (user: User) => user?.fullName || DEFAULT_USER_NAME);
